import { create_product_order, query_product_order_list } from '@/api/jms-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/company/company-productorder-config';

import { reactive } from 'vue';
import {get_is_active, get_is_active2, getDateTime, toFixed0} from '@/utils/function';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '订单单号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写订单单号',
    },
    {
      type: 'remotemodal',
      name: 'order_id',
      label: '隶属报单',
      disabled: false,
      placeholder: '请选择隶属报单',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'jms-requestorder',
    },
    {
      type: 'remotemodal',
      name: 'franchisee_id',
      label: '加盟商',
      disabled: false,
      placeholder: '请选择加盟商',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'jms-franchisee',
    },
    {
      type: 'remotemodal',
      name: 'product_id',
      label: '产品',
      disabled: false,
      placeholder: '请选择产品',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'jms-product',
    },
    {
      type: 'rangepicker',
      name: 'date',
      label: '下单时间',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      placeholder: '请填写下单时间',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    code: null,
    order_id: null,
    franchisee_id: null,
    product_id: null,
    date: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    {
      type: 'remotemodal',
      name: 'order_id',
      label: '隶属报单',
      disabled: false,
      placeholder: '请选择隶属报单',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'jms-requestorder',
    },
    {
      type: 'datepicker',
      name: 'date',
      label: '下单时间',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: true,
      placeholder: '请填写下单时间',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    order_id: null,
    date: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '订单管理',
  addModalTitle: '新建订单',
  updateTitle: '修改订单',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    id: 'id',
  },
  delete: {
    id: 'id',
  },
  recover: {
    id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
  },
  {
    title: '订单单号',
    width: 150,
    dataIndex: 'code',
    fixed: 'left',
    checked: false,
  },

  {
    title: '报单单号',
    width: 150,
    dataIndex: 'order__code',
    fixed: 'left',
    checked: false,
  },
  {
    title: '产品编号',
    width: 150,
    dataIndex: 'product__code',
    checked: true,
  },
  {
    title: '产品名称',
    width: 150,
    dataIndex: 'product__name',
    checked: true,
  },
  {
    title: '加盟商',
    width: 150,
    dataIndex: 'franchisee__name',
    checked: true,
  },
  {
    title: '产品数量',
    width: 100,
    dataIndex: 'num',
    checked: true,
  },
  {
    title: '产品余次',
    width: 100,
    dataIndex: 'no_num',
    checked: true,
  },
  {
    title: '产品单价',
    width: 150,
    dataIndex: 'price',
    checked: true,
    content: (record: any, text: any) => {
      return toFixed0(text);
    },
  },
  {
    title: '产品金额',
    width: 150,
    dataIndex: 'total_price',
    checked: true,
    content: (record: any, text: any) => {
      return toFixed0(text);
    },
  },
  {
    title: '下单时间',
    width: 150,
    dataIndex: 'date',
    checked: true,
    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    checked: true,
    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  {
    title: '备注',
    width: 150,
    dataIndex: 'mark',
    checked: true,
  },
  {
    title: 'ID',
    width: 150,
    dataIndex: 'id',
    checked: false,
  },
  {
    title: '产品订单ID',
    width: 150,
    dataIndex: 'order_id',
    checked: false,
  },
  {
    title: '加盟商ID',
    width: 150,
    dataIndex: 'franchisee_id',
    checked: false,
  },

  {
    title: '产品ID',
    width: 150,
    dataIndex: 'product_id',
    checked: false,
  },
  {
    title: '更新时间',
    width: 150,
    dataIndex: 'update_time',
    checked: false,
    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  // {
  //   title: '是否可用',
  //   width: 150,
  //   dataIndex: 'is_active',
  //   checked: false,
  //   cellComponent: 'boolean',
  //   name1: '可用',
  //   name2: '禁用',
  //   filterMultiple: false,
  //   filters: [
  //     { text: '全部', value: '' },
  //     { text: '可用', value: true },
  //     { text: '作废', value: false },
  //   ],
  //   content: (record: any, text: any) => {
  //     return get_is_active(text);
  //   },
  // },
  {
    title: '操作',
    width: 200,
    dataIndex: 'is_active',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active2(text);
    },
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push({
  type: 'custom',
  // slotName: 'is_active',
  field_true: '可用',
  field_false: '作废',
});

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_product_order_list,
    addData: create_product_order,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
